import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { UPLOADS_BASE_URL } from '../config/api';
import { getAvatarStyle, getInitials } from '../utils/avatarUtils';

const UserBadge: React.FC = () => {
  const { user, userDetails } = useAuth();

  return (
    <div className="d-flex align-items-center gap-2">
      {/* Avatar */}
      {userDetails?.logo ? (
        <img
          src={`${UPLOADS_BASE_URL}${userDetails.logo}`}
          alt="Organization Logo"
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '6px',
            objectFit: 'contain',
            background: 'transparent',
          }}
        />
      ) : userDetails?.name ? (
        <div style={getAvatarStyle(userDetails.name, 40)}>
          {getInitials(userDetails.name)}
        </div>
      ) : null}

      {/* Name and Organization */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
        <span style={{ color: '#687088', fontWeight: 600, fontSize: '16px', whiteSpace: 'nowrap' }}>
          {userDetails?.name || user?.name || 'Benutzer'}
        </span>
        {userDetails?.organization && (
          <span style={{ color: '#687088', fontWeight: 400, fontSize: '14px', whiteSpace: 'nowrap' }}>
            {userDetails.organization}
          </span>
        )}
      </div>
    </div>
  );
};

export default UserBadge;
